import { useEffect, useRef } from 'react';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

export const useProductBackHandler = (view, checkoutStep, handleInternalViewChange) => {
  const lastBackPress = useRef(0);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const handler = App.addListener('backButton', () => {
      // Only handle back for product/checkout flow
      if (view === 'product') {
        handleInternalViewChange('orders'); // Back from product to marketplace/orders
        return;
      }

      if (view === 'checkout') {
        switch (checkoutStep) {
          case 'cart':
            handleInternalViewChange('marketplaceProductView'); // Back to product detail
            return;
          case 'address':
            handleInternalViewChange('checkoutView'); // Back to cart
            return;
          case 'confirmation':
            handleInternalViewChange('addressView'); // Back to address form
            return;
          case 'payment':
            handleInternalViewChange('confirmationView'); // Back to confirmation
            return;
          case 'success':
            // Ignore back on success; optionally go to marketplace
            handleInternalViewChange('orders');
            return;
          default:
            handleInternalViewChange('checkoutView');
            return;
        }
      }
    });

    return () => handler.remove();
  }, [view, checkoutStep, handleInternalViewChange]);
};
